module.exports = __webpack_public_path__ + "static/media/anno_acc.fb7096db.png";